module.exports = __webpack_public_path__ + "static/media/phone_footer_border.5b9a9e18.svg";